import React, { useEffect, useState } from 'react';
import {
    ButtonGroupItem,
    ButtonField,
    ButtonGroup,
    InputField,
    Modal,
    ModalHeader,
    ModalBody,
    ModalFooter,
    Iconsvg,
    Multiselect,
    ButtonFieldIcon,
} from '@wk/components-react16';
import { Toast } from '../../../services';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { RootState } from '../../../store';
import { useSelector, useDispatch } from 'react-redux';
import { showLoading, hideLoading } from "../../../store/authReducer";

const AddDeleteValidationCases = ({ data }: any) => {
    const { isOpenValidationCases, setIsOpenValidationCases, validationCases, setIsLoad } = data;
	const dispatch = useDispatch();
    const { authProject } = useSelector((state: RootState) => state.auth);
    const [validationRuleList, setValidationRuleList] = useState([] as any);
    const [newValidationRuleList, setNewValidationRuleList] = useState([] as any);

    const handleInputChange = (index: number, event: any) => {
        const newList = [...newValidationRuleList];
        const { name, value } = event.target;
        newList[index][name] = value;
        setNewValidationRuleList(newList);
    };

    const getValidationRule = () => {
        dispatch(showLoading());
        HttpService.getRequest(`${API_URL.GET_VALIDATION}?projectId=${authProject.id}`).then(
            (res: any) => {
                let list = res.map((item: any) => ({ ...item, label: item.name, isSelected: false }));
                if (validationCases.validations.length > 0) {
                    list.forEach((item: any) => {
                        item.isSelected = validationCases.validations.some((itm: any) => itm.id == item.id);
                    });
                }
                setValidationRuleList(list);
                dispatch(hideLoading());
            },
            (err: any) => {
                Toast(err.message, "error");
                dispatch(hideLoading());
            },
        )
    }

    const isValid = () => {
        for (let rule of newValidationRuleList) {
            if (!rule.name || !rule.name.trim() || !rule.text || !rule.text.trim()) {
                Toast('All validation name and text fields must be filled.', "error");
                return false;
            }
        }
        return true;
    };

    const saveValidationCases = () => {
        if (!isValid()) return;
        const rulelist:  any = validationRuleList.filter((item: any) => item.isSelected === true);
        /* if (rulelist.length === 0 && newValidationRuleList.length === 0){
            Toast('Please select or add new validation rule.', "error");
			return;
        } */
        const validationRules = rulelist.map((item: any) => ({ id: item.id, name: item.name, text: item.text, projectId: authProject.id }));
        const payload: any = {
            promptId: validationCases.id,
            validationRule: [...validationRules, ...newValidationRuleList]
        }
        dispatch(showLoading());
        HttpService.postRequest(API_URL.VALIDATION_PROMPT_MAPPING, payload).then(
            (res: any) => {
                dispatch(hideLoading());
                Toast((payload.validationRule?.length > validationCases?.validations?.length) ? 'Validation rule(s) added successfully.' : 'Validation rule(s) updated successfully.', "success");
                setIsOpenValidationCases(false);
                setIsLoad(true);
            },
            (err: any) => {
                Toast(err.message, "error");
                dispatch(hideLoading());
            }
        )
    }

    const handleNewValidationRule = () => {
        setNewValidationRuleList([
            ...newValidationRuleList,
            {
                id: null,
                name: '',
                text: '',
                projectId: authProject.id
            }
        ]);
    }

    const removeNewValidationRule = (itemIndex: any) => {
        const updatedList = newValidationRuleList.filter((item: any, index: any) => itemIndex !== index);
        setNewValidationRuleList(updatedList);
    }

    useEffect(() => {
        if (authProject && authProject.id) {
            getValidationRule();
        }
    }, []);

    return (
        <div className='custom-modal custom-modal-body'>
            <Modal
                isOpen={isOpenValidationCases}
                srLabelledBy={'modal-id-V1'}
                srDescribedBy={'modal-id-V2'}
                onUserRequest={(event: any) => setIsOpenValidationCases(false)}>
                <ModalHeader
                    titleId={'modal-id-V1'}
                    isFullscreenButtonVisible
                    onUserRequest={() => setIsOpenValidationCases(false)}>
                    Validation Cases
                </ModalHeader>
                <ModalBody descriptionId="modal-id-V2">
                    <div className="pl-20 pr-20 pt-15 pb-10 rounded-3 border-light-subtle custom-fs-field" style={{ backgroundColor: '#F1F2F3', minHeight: '100%' }}>
                        {validationCases.isShow ? <div className='position-relative custom-overflow-inherit'>
                            <Multiselect
                                onItemUserRequest={(item: any) => {
                                    const list = [...validationRuleList];
                                    setValidationRuleList(list);
                                    }
                                }
                                onPillUserRequest={() => {
                                    const list = [...validationRuleList];
                                    setValidationRuleList(list);
                                }
                                }
                                items={validationRuleList}
                                pillLabel="Validation rule assigned"
                                placeholder="Select Validation"
                                size="small"
                                label="Select Validation Rules"
                                indicator="required"></Multiselect>
                            <div className="cg-field-header" style={{ fontSize: '0.875rem' }}>
                                <label className="cg-field-label">Add New Validation Rule</label>
                                <div className="p-5 cursor-pointer" title='Add New Validation Rule' onClick={() => handleNewValidationRule()}>
                                    <Iconsvg name={"plus"} color='#9A67F3'></Iconsvg>
                                </div>
                            </div>
                            {newValidationRuleList.length > 0 ? newValidationRuleList.map((validation: any, index: any) => (
                                <div className="mb-10 rounded-3 pl-15 pr-15 pt-10 bg-white text-wrap fw-normal border border-primary-subtle wk-size-2 position-relative" key={index}>
                                    <div className="position-absolute top-0 end-0 mr-10 p-5 cursor-pointer" onClick={() => removeNewValidationRule(index)}>
                                        <Iconsvg name="trash" color='#DC3545' size={14}></Iconsvg>
                                    </div>
                                    <InputField label="Validation Name" labelFor="validation-name-1" size="small" indicator="required">
                                        <input
                                            type="text" id="validation-name-1" name="name"
                                            placeholder="Validation Name"
                                            onChange={(event: any) => handleInputChange(index, event)}
                                            value={validation.name} autoComplete="off"
                                        />
                                    </InputField>
                                    <InputField label="Validation Description" labelFor="validation-text-1" size="small" indicator="required">
                                        <input
                                            type="text" id="validation-text-1" name="text"
                                            placeholder="Validation Description"
                                            onChange={(event: any) => handleInputChange(index, event)}
                                            value={validation.text} autoComplete="off"
                                        />
                                    </InputField>
                                </div>
                            )) : null}
                        </div> : <>
                            {validationCases.validations.length > 0 ? validationCases.validations.map((item: any, index: any) => (
                                <div className="custom-input-icon" key={index}>
                                    <div className='mb-10 rounded-3 pl-15 pr-15 pt-10 pb-10 bg-white text-wrap fw-normal border border-primary-subtle wk-size-2' key={index}>
                                        <div className='wk-size-1 wk-weight-500'>{item.name}</div>
                                        <div className='wk-size-1'>{item.text}</div>
                                    </div>
                                </div>
                            )) : <div>No Validation Cases.</div>}
                        </>}
                    </div>
                </ModalBody>
                {validationCases.isShow ? <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField mode={'text'}>
                                <button
                                    type="button"
                                    id="cancel"
                                    onClick={() => setIsOpenValidationCases(false)}>
                                    Cancel
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField>
                                <button
                                    type="button"
                                    id="saveValidation"
                                    onClick={() =>
                                        saveValidationCases()
                                    }>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter> : null}
            </Modal>
        </div>
    )
}

export default AddDeleteValidationCases;